import { loadFromGleapCache, saveToGleapCache } from "./CacheReader";

const KEY_PREFIX = "gleap-chatbar-active-ticket:";

const keyFor = (gleapId?: string | null): string | null =>
  gleapId ? `${KEY_PREFIX}${gleapId}` : null;

export interface CachedChatbarTicket {
  shareToken: string;
  id: string;
}

// Persist the single "most recent conversation the user wrote into" so focusing
// the chatbar can reopen it instantly, without waiting on the conversation list.
// Scoped by gleapId so a different session can't reopen someone else's thread.
// No-ops when gleapId is missing or the ticket lacks the ids needed to reopen.
export const saveActiveChatbarTicket = (
  gleapId: string | null | undefined,
  ticket: { shareToken?: string; id?: string } | null | undefined,
): void => {
  const key = keyFor(gleapId);
  if (!key) return;
  const shareToken = ticket?.shareToken;
  const id = ticket?.id;
  if (!shareToken || !id) return;
  saveToGleapCache(key, { shareToken, id });
};

export const getActiveChatbarTicket = (
  gleapId: string | null | undefined,
): CachedChatbarTicket | null => {
  const key = keyFor(gleapId);
  if (!key) return null;
  const cached = loadFromGleapCache(key);
  if (cached && cached.shareToken && cached.id) {
    return { shareToken: cached.shareToken, id: cached.id };
  }
  return null;
};

export const clearActiveChatbarTicket = (
  gleapId: string | null | undefined,
): void => {
  const key = keyFor(gleapId);
  if (!key) return;
  saveToGleapCache(key, null); // falsy data → removeItem
};

// A reopened conversation stays open unless the fresh fetch says it's resolved.
export const isReopenableStatus = (status?: string | null): boolean =>
  status !== "DONE" && status !== "CLOSED";
